


















































































































import { EmailInvite, Sheet, SheetRequest } from '@/model/Sheet';
import { Component, Emit, Prop } from 'vue-property-decorator';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { ApiError } from '@/model/ApiError';
import { mixins } from 'vue-class-component';
import ToastMixin from '@/mixins/ToastMixin';
import ToastVariant from '@/model/enums/toast/toast-variant';
import CustomModal from '@/components/modal/CustomModal.vue';
import CreateSheetModal from '@/active-components/sheet/CreateSheetModal.vue';
import InviteFormSheet from '@/components/sheet/InviteFormSheet.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';

@Component({
    components: {
        CreateSheetModal,
        CustomModal,
        InviteFormSheet,
        ConfirmationModal,
    },
    computed: {
        ...mapGetters({
            error: 'sheetStorage/getError',
            projectSheets: 'sheetStorage/getProjectSheets',
        }),
    },
    methods: {
        ...mapMutations({
            setError: 'sheetStorage/setError',
            setProjectSheets: 'sheetStorage/setProjectSheets',
        }),
        ...mapActions({
            fetchProjectSheets: 'sheetStorage/fetchProjectSheets',
            invite: 'sheetStorage/invite',
            remove: 'sheetStorage/remove',
            update: 'sheetStorage/update',
        }),
    },
})
export default class SheetModal extends mixins(ToastMixin) {
    @Prop() sheet!: Sheet;

    formData = { ...this.sheet };

    update!: (request: SheetRequest) => Promise<void>;

    setError!: (error: ApiError | null) => void;

    loading = true;

    fetchProjectSheets!: (eventId: number) => Promise<void | Sheet[]>;

    remove!: (sheetId: number) => Promise<void>;

    setProjectSheets!: (projectSheets: Sheet[] | null) => void;

    projectSheets!: Sheet[];

    invite!: (emailInvite: EmailInvite) => Promise<void>;

    eventId: number = +this.$route.params.id;

    mounted(): void {
        this.fetch();
    }

    fetch(): void {
        this.loading = true;
        this.fetchProjectSheets(this.eventId).finally(() => {
            this.loading = false;
        });
    }

    @Emit()
    onCreateOrUpdateSuccess(isUpdate: boolean): void {
        this.fetch();
        this.$nextTick(() => {
            this.showToast(
                this.$t(
                    `sheet.notification.${isUpdate ? 'update-' : ''}successful`,
                ).toString(),
                this.$t('sheet.notification.title').toString(),
                ToastVariant.SUCCESS,
            );
        });
        this.$bvModal.hide('create-sheet-modal');
    }

    openCreate(): void {
        this.formData = { ...this.sheet };
        this.$bvModal.show('create-sheet-modal');
    }

    openEdit(sheet: Sheet): void {
        this.formData = { ...sheet };
        this.$bvModal.show('create-sheet-modal');
    }

    openInvite(sheet: Sheet): void {
        this.formData = { ...sheet };
        this.$bvModal.show('invite-modal');
    }

    openRemove(sheet: Sheet): void {
        this.formData = { ...sheet };
        this.$bvModal.show('remove-modal');
    }

    openUpdate(sheet: Sheet): void {
        this.formData = { ...sheet };
        this.$bvModal.show('update-modal');
    }

    onRemove(): void {
        if (this.formData.id) {
            this.loading = true;
            this.remove(this.formData.id)
                .then(() => {
                    this.fetch();
                    this.$bvModal.hide('remove-modal');
                    this.showToast(
                        this.$t('sheet.popup.delete.success').toString(),
                        this.$t('sheet.popup.delete.title').toString(),
                        ToastVariant.SUCCESS,
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }

    onUpdate(): void {
        if (this.formData.id) {
            this.loading = true;
            const updated = {
                ...this.sheet,
                id: this.formData.id,
                name: this.formData.name,
            };
            this.update({ eventId: this.eventId, sheet: updated })
                .then(() => {
                    this.fetch();
                    this.$bvModal.hide('update-modal');
                    this.showToast(
                        this.$t('sheet.popup.update.success').toString(),
                        this.$t('sheet.popup.update.title').toString(),
                        ToastVariant.SUCCESS,
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }

    onInvite(email: string): void {
        if (this.formData.id) {
            this.invite({
                email,
                sheetId: this.formData.id,
            }).then(() => {
                this.$bvModal.hide('invite-modal');
                this.showToast(
                    this.$t('sheet.popup.share.success').toString(),
                    this.$t('sheet.popup.share.title').toString(),
                    ToastVariant.SUCCESS,
                );
            });
        }
    }

    destroyed(): void {
        this.setError(null);
        this.setProjectSheets(null);
    }
}
